<template>
  <div>
    <el-select :value="value" value-key="key" :size="size" @input="change($event)">
      <el-option label="流量" value="traffic" />
      <el-option label="语音" value="voice" />
      <el-option label="短信" value="message" />
      <el-option label="连接" value="connection"/>
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/PackageItemTypeSelect.vue